import { Component, OnInit } from '@angular/core';
import { ConditionCodeService } from '../../services/condition-code.service';
import { SharedService } from '../../services/shared.service';
import { IConditionCodeDto, IConditionCodePagedResultDto } from '../../interfaces/Kroll/icondition-code-dto';

declare var bootstrap: any;

@Component({
  selector: 'app-condition-codes',
  templateUrl: './condition-codes.component.html',
  styleUrls: ['./condition-codes.component.css']
})
export class ConditionCodesComponent implements OnInit {
  result: IConditionCodePagedResultDto = { items: [], totalCount: 0 };
  loading = false;
  page = 1;
  pageSize = 25;
  searchCode = '';
  searchDescription = '';
  includeDeleted = true;

  editingItem: IConditionCodeDto | null = null;
  isCreate = false;
  formCode = '';
  formDescription = '';
  formIsDeleted = false;
  showErrorMessage = false;
  errorMessage = '';

  constructor(
    private conditionCodeService: ConditionCodeService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.load();
  }

  load() {
    this.loading = true;
    this.showErrorMessage = false;
    this.conditionCodeService
      .getConditionCodes(this.page, this.pageSize, this.searchCode, this.searchDescription, this.includeDeleted)
      .subscribe({
        next: (data) => {
          const raw = data || {};
          const list = raw['items'] || raw['Items'] || [];
          this.result = {
            items: list.map((it: any) => ({
              id: it['id'] != null ? it['id'] : it['Id'],
              code: it['code'] != null ? it['code'] : it['Code'],
              description: it['description'] != null ? it['description'] : it['Description'],
              createdDate: it['createdDate'] || it['CreatedDate'],
              updatedDate: it['updatedDate'] || it['UpdatedDate'],
              isDeleted: it['isDeleted'] != null ? it['isDeleted'] : it['IsDeleted']
            })),
            totalCount: raw['totalCount'] != null ? raw['totalCount'] : (raw['TotalCount'] != null ? raw['TotalCount'] : 0)
          };
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.showErrorMessage = true;
          this.errorMessage = (err && err.error && err.error.message) || (err && err.message) || 'Failed to load Condition Codes.';
          setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 8000);
        }
      });
  }

  onSearch() {
    this.page = 1;
    this.load();
  }

  onPageChange(newPage: number) {
    if (newPage < 1 || newPage > this.totalPages) return;
    this.page = newPage;
    this.load();
  }

  get totalPages(): number {
    if (this.pageSize <= 0) return 0;
    return Math.max(1, Math.ceil(((this.result && this.result.totalCount) || 0) / this.pageSize));
  }

  openCreate() {
    this.isCreate = true;
    this.editingItem = null;
    this.formCode = '';
    this.formDescription = '';
    this.formIsDeleted = false;
    this.openModal('conditionCodeModal');
  }

  openEdit(item: IConditionCodeDto) {
    this.isCreate = false;
    this.editingItem = item;
    this.formCode = item.code || '';
    this.formDescription = item.description || '';
    this.formIsDeleted = item.isDeleted || false;
    this.openModal('conditionCodeModal');
  }

  save() {
    const code = (this.formCode || '').trim();
    if (!code) {
      this.showErrorMessage = true;
      this.errorMessage = 'Code is required.';
      setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 5000);
      return;
    }
    if (this.isCreate) {
      this.conditionCodeService.createConditionCode({ code, description: (this.formDescription || '').trim() }).subscribe({
        next: () => {
          this.closeModal('conditionCodeModal');
          this.load();
          this.sharedService.showSuccessMessage = true;
        },
        error: (err) => {
          this.showErrorMessage = true;
          this.errorMessage = (err && err.error && err.error.message) || (err && err.message) || 'Create failed.';
          setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 5000);
        }
      });
    } else if (this.editingItem) {
      this.conditionCodeService.updateConditionCode(this.editingItem.id, {
        code,
        description: (this.formDescription || '').trim(),
        isDeleted: this.formIsDeleted
      }).subscribe({
        next: () => {
          this.closeModal('conditionCodeModal');
          this.load();
          this.sharedService.showSuccessMessage = true;
        },
        error: (err) => {
          this.showErrorMessage = true;
          this.errorMessage = (err && err.error && err.error.message) || (err && err.message) || 'Update failed.';
          setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 5000);
        }
      });
    }
  }

  openModal(modalId: string) {
    const el = document.getElementById(modalId);
    if (el) new bootstrap.Modal(el).show();
  }

  closeModal(modalId: string) {
    const el = document.getElementById(modalId);
    const modal = bootstrap.Modal.getInstance(el);
    if (modal) modal.hide();
  }
}
